module.exports = __webpack_public_path__ + "img/keyboard-enter.2b579e5a.svg";